import { ConfiguracionFormattDate, ConfiguracionFormatterById } from 'api/configuraciones/ConfigModelFormatters';
import CRUDgeneric from 'utils/CRUDgeneric';

const _cliente = CRUDgeneric('/catalogos/periodos-vacacionales/');
const _nameModel = 'Periodos Vacacionales';
const _nameModelSingular = 'el Periodo Vacional';
/**
 * GET Periodos Vacacionales
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getPeriodosVacacionales = async (params) => (
  _cliente.obtenerListaDeRegistros(params)
);

const _formatRecordForRead = (record) => ConfiguracionFormatterById(record);
const _formatRecordForSend = (record) => ConfiguracionFormattDate(record);

// Empaqueto todo en un objeto
/** permite llamarlo facilmente por el editor */
export const ModelPeriodosVacacionales = {
  cliente: _cliente,
  nameModel: _nameModel,
  nameModelSingular: _nameModelSingular,
  formatter: { // el actor que formatea.
    formatRecordForRead: _formatRecordForRead,
    formatRecordForSend: _formatRecordForSend,
  },
};
